module.exports = __webpack_public_path__ + "fonts/VetoSansCond-BoldItalic_1.6600c9b5.woff";